import { render, staticRenderFns } from "./ButtonModelStock.vue?vue&type=template&id=56c91fdc&scoped=true"
import script from "./ButtonModelStock.vue?vue&type=script&lang=js"
export * from "./ButtonModelStock.vue?vue&type=script&lang=js"
import style0 from "./ButtonModelStock.vue?vue&type=style&index=0&id=56c91fdc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c91fdc",
  null
  
)

export default component.exports